import React, { PureComponent, ReactNode, useEffect, useState } from 'react';
import { batch, connect, useDispatch } from 'react-redux';
import moment from 'moment';
import {
    addVisit,
    deletePatientByLocalId,
    getDoc,
    getItemFromMisc,
    getPatientByLocalId,
    getPrescriptionById,
    getPrintConfig,
    getVisitById,
    MISC_KEYS,
    updatePrescriptionUrlAndVisitNameInVisit,
    updatePtInPx,
    upsertPatient,
    upsertPrescription,
    upsertVisits,
    updatePtInVisit,
    getPrescriptionsByVisitId,
    getTemplates,
    markPrescriptionAsPushFailedStatus,
    getDocIds,
    getDoctorProfile,
} from '../store/idbHandler';
import { Prescription, VitalsEntity } from '../store/types/prescription';
import { isLocalPt, Patient } from '../store/types/patient';
import { Visit } from '../store/types/visit';
import triggerVisitSMS from '../api/triggerVisitSMS';
import { createDBTool, generateVisitName } from '../store/utils';
import PrescriptionPDFPreview from './PrescriptionPDFPreview';
import { ThunkDispatch } from 'redux-thunk';
import { GlobalState } from '../store/reducers';
import { Actions } from '../store/actions';
import fetchPatientDirByDocOid, {
    VisitsEntity,
    Patient as PatientDirPt,
} from '../api/fetchPatientDirByDocOid';
import fetchPrescriptionById, { Px } from '../api/fetchPrescriptionById';
import {
    AssessmentSummaryError,
    AssessmentSummary,
    filterPresentingSymptoms,
    filterDiagonsis,
    filterMedicalHistory,
} from './prescriptionPad/AssessmentSummaryRightPanel';
import fetchAssessmentSummary, {
    AssessmentSummaryEntity,
    MH_FA,
    MH_FH,
    MH_LH,
    MH_MC,
    MH_PP,
    SA,
} from '../api/fetchAssessmentSummary';
import AppLoader from '../components/common/AppLoader';
import VideoRecording from './patientDetails/VideoRecording';
import {
    getAllVisitsWithLinkedPatientIds,
    getPxPrintUrl,
    isBusinessVisit,
    isIPad,
    isMrVisit,
    isSelfVisit,
    parseDoctorName,
    isEditableVisitForMe,
    getPxSendUrl,
} from './utils';
import { GenieSettings, SREV2 } from '../api/pushGenie';
import { AnimatePresence } from 'framer-motion';
import CreateTemplateComp from '../components/prescriptionPad/rightPanel/finishScreen/CreateTemplateDialog';
import {
    createPrescriptionTemplate,
    updateVitals,
    upsertDiagnose,
    upsertLabVital,
    upsertMedicalHistory,
    upsertSymptom,
} from '../store/actions/prescriptionPad';
import { pushVisit } from '../api';
import { CHANNEL_SA, DIAGNOSIS, SELECT, SYMPTOM, track, VITAL } from '../tracking';
import { WithKeyboardPressHandling } from '../components/common/WithKeyboardPressHandling';
import { captureError } from './captureError';
import RXPreviewPtDetails from '../components/RXPreviewPtDetails';
import { NoPx } from '../components/common/NoPX';
import { ALREADY_SAVED, LATEST_DRAFT_NOT_APPLIED } from '../api/pushVisit';
import { showOverrideVisitDialog } from '../components/common/overrideVisitDialog';
import VisitDataWrapper from '../components/prescriptionPad/rightPanel/VisitDataWrapper';
import { setIsNotesMode } from '../store/actions/session';
import { initVisit } from '../store/actions/visit';
import { openPrescriptionPadForVisit } from './AppointmentUtils';
import {
    GO_TO_FETCH_UPSERT_PRESCRIPTION_WITH_ID,
    GO_TO_PRESCRIPTION_PAD,
    GO_TO_PRESCRIPTION_PAD_V2,
} from '../routes/paths';
import { AP } from './Appointments';
import { Draft } from '../api/fetchPxDraft';
import { DOC_TOOL } from '../api/constants';
import { ALL_KINDS } from '../utils/enums';
import { getMyDbId, getMyIdWithBackwardCompatibility } from '../api/mactiveid';
import fetchPastAssessmentSummary from '../api/fetchPastAssessmentSummary';
import { MEDICAL_HISTORY_CATEGORY } from '../store/types/medicalHistory';
import fetchBatchAssessmentSummary from '../api/fetchBatchAssessmentSummary';
import { getAclViewClassName } from '../restrictions/utils';
import { getMActiveId } from '../store/localstorage';
import { updateAddVisit } from '../utils/commons';
import { SERVER_VITALS } from '../components/prescriptionPad/leftPanel/vitals';
import { rxWithoutLatestDraft } from '../components/common/rxWithoutLatestDraft';
import { AntTooltip } from '../components/common/AntTooltip';
import { PDFViewer } from '../components/PDFViewer';

const SaveAsTemplateBt: React.FC<{ onClick: () => void }> = ({ onClick }) => {
    return (
        <button
            onClick={onClick}
            className={`secondary-btn justify-center btn px-8 py-8 btn--small w-full space-x-4 ${getAclViewClassName(
                SREV2.CAN_CREATE_RX_TEMPLATE,
            )}`}
        >
            <div className="w-20 h-20 flex items-center justify-center">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    className="fill-actionPrimary cursor-pointer"
                >
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M16 1H4a2 2 0 00-2 2v14h2V3h12V1zm-1 4l6 6v10a2 2 0 01-2 2H7.99A2 2 0 016 21l.01-14A2 2 0 018 5h7zm-1 7h5.5L14 6.5V12z"></path>
                </svg>
            </div>

            <span className="whitespace-nowrap text-center">Save as Template</span>
        </button>
    );
};

type SSBC = {
    ph: string;
    visitId: string;
    disabled?: boolean;
};

const SendSMSBt: React.FC<SSBC> = ({ ph, visitId, disabled }) => {
    const onClick = (): void => {
        triggerVisitSMS(visitId)
            .then((r) => {
                try {
                    r.wpString &&
                        window.open(
                            `https://api.whatsapp.com/send?phone=${ph}&text=${r.wpString}`,
                            '_blank',
                        );
                } catch (e) {
                    console.error('triggerVisitSMS, window.open', e);
                }
            })
            .catch(() => {
                alert('Error sending SMS/WhatsApp');
            });
    };
    return (
        <button
            onClick={!disabled ? onClick : undefined}
            className={`w-full justify-center secondary-btn btn px-8 py-8 btn--small space-x-4 ${getAclViewClassName(
                SREV2.SEND_RX,
            )}`}
            style={disabled ? { opacity: 0.5 } : undefined}
        >
            <div className="w-20 h-20 flex items-center justify-center">
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 28 28"
                    className="fill-actionPrimary cursor-pointer relative top-1"
                >
                    <path d="M2,21L23,12L2,3V10L17,12L2,14V21Z"></path>
                </svg>
            </div>
            <span className="whitespace-nowrap text-center">Send SMS/WhatsApp</span>
        </button>
    );
};

interface Props {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    history: any;
    plId: string;
    vId?: string;
    goToVisit: (vId: string) => void;
    editPx?: (pxId: string) => void;
    onUseAsTemplate: (pxId: string) => void;
    onPxSyncComplete: (patient: Patient) => void;
}

export type VisitWithLocalMassaging = Visit & {
    localInCompletePxId?: string[];
};

type State = {
    visit?: VisitWithLocalMassaging & { draft?: Draft };
    upcoming_visit?: VisitWithLocalMassaging & { draft: Draft };
    allVisits: VisitWithLocalMassaging[];
    prescription?: Prescription;
    selectedTab: 'prescription' | 'notes' | 'video' | 'sa' | 'digital-prescription' | 'apt-details';
    createTemplateVisit?: Visit;
    isResyncing?: boolean;
    isLoading?: boolean;
    isForce?: boolean;
    isIgnoreDraft?: boolean;
};

const PX_PDF_ELEMENT_ID = 'PX_PDF_ELEMENT_ID';
const RIGHT_PANEL_CONC = 'RIGHT_PANEL_CONC';

const VISIT_STATUS_ICON: { [k: string]: ReactNode } = {
    AB: (
        <svg
            className="w-16 h-16 fill-neutral-6"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <path d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM48 256c0-48.71 16.95-93.47 45.11-128.1l291.9 291.9C349.5 447 304.7 464 256 464C141.3 464 48 370.7 48 256zM418.9 384.1L127 93.11C162.5 64.95 207.3 48 256 48c114.7 0 208 93.31 208 208C464 304.7 447 349.5 418.9 384.1z"></path>
        </svg>
    ),
    NS: (
        <svg
            className="w-16 h-16 fill-neutral-6"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
        >
            <path d="M336.1 175c-9.375-9.375-24.56-9.375-33.94 0L256 222.1L208.1 175c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l47.03 47.03L175 303c-9.375 9.375-9.375 24.56 0 33.94c9.373 9.373 24.56 9.381 33.94 0L256 289.9l47.03 47.03c9.373 9.373 24.56 9.381 33.94 0c9.375-9.375 9.375-24.56 0-33.94l-47.03-47.03l47.03-47.03C346.3 199.6 346.3 184.4 336.1 175zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256S512 397.4 512 256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464z"></path>
        </svg>
    ),
    BK: (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 576 512"
            className="w-16 h-16"
            style={{ fill: '#FF6208' }}
        >
            <path d="M64 464H262.5l-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V299.6l-48 48V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" />
        </svg>
    ),
};

class PastVisitsRightPanel extends PureComponent<Props, State> {
    state: State = {
        allVisits: [],
        upcoming_visit: undefined,
        selectedTab: 'prescription',
        isLoading: false,
    };

    setSelectedTab = (
        tab: 'prescription' | 'digital-prescription' | 'notes' | 'video' | 'sa' | 'apt-details',
    ) => {
        this.setState({
            selectedTab: tab,
        });
    };

    onMount = () => {
        this.fetchVisits();

        this.setUp();
    };

    componentDidMount = async (): Promise<void> => {
        this.onMount();
    };

    setUp = async () => {
        const allVisits = await getAllVisitsWithLinkedPatientIds(this.props.plId);
        const upcoming_visit = this.state.upcoming_visit;

        if (!allVisits || allVisits.length === 0) {
            if (!!upcoming_visit) {
                this.setState({
                    allVisits: [upcoming_visit],
                    visit: upcoming_visit,
                    prescription: {
                        ...upcoming_visit.draft?.data.tool,
                    } as any,
                });
                this.props.goToVisit(upcoming_visit.id);
                return;
            }
            this.setState({
                allVisits: [],
            });
            return;
        }

        const allVisitsWithLocalMassaging: (Visit & {
            localInCompletePxId?: string[];
        })[] = [];

        for (let index = 0; index < allVisits.length; index++) {
            const v: Visit & {
                localInCompletePxId?: string[];
            } = allVisits[index];

            if (v.status === 'CMNP' || v.status === 'NS' || v.status === 'AB') {
                const pxIds = (await getPrescriptionsByVisitId(v.id))?.map((t) => t.id) || [];
                v.localInCompletePxId = pxIds;

                if (pxIds.length) {
                    track('FOUND_INCOMPLETE_PX', { pres_id: pxIds.toString(), visit_id: v.id });
                }
            }
            allVisitsWithLocalMassaging.push(v);
        }
        if (!!upcoming_visit) {
            allVisitsWithLocalMassaging.unshift(upcoming_visit);
        }
        this.setState({
            allVisits: allVisitsWithLocalMassaging,
        });

        this.fetchDeets(allVisitsWithLocalMassaging);
    };

    fetchVisits = async () => {
        if (isLocalPt(this.props.plId)) {
            // local pt, can't fetch past visits from BE for a local patient
            track('ERROR', { on: 'fetching past visits for a local patient id' });
            return;
        }
        this.setState({
            isLoading: true,
        });

        const settings = await getItemFromMisc<GenieSettings>(getMActiveId() || '', 'settings');

        fetchPatientDirByDocOid(settings.bizLevelPt ? ['all'] : getDocIds(), this.props.plId)
            .then(async (res) => {
                const pts = res.data?.filter((item) => item.id === this.props.plId);

                if (res.status !== 'success' || !res.data || pts?.length !== 1) {
                    console.error('No data found');
                    alert('Failed to fetch latest details of the patient  [4]');
                    track('ERROR', { on: 'fetching latest details of the patient' });
                    return;
                }

                let upcoming_visit;

                const upsertsPromises: (Promise<void> | void)[] = res.data.reduce(
                    (upserts, pt) =>
                        pt.visits
                            ? upserts.concat(
                                  pt.visits.map((v) => {
                                      if (v.status === 'BK') {
                                          upcoming_visit = convertVisitToLocalMasaggingFormat(
                                              pt,
                                              v,
                                          );
                                          return;
                                      }
                                      return updateAddVisit(pt, v);
                                  }),
                              )
                            : upserts,
                    [] as (Promise<void> | void)[],
                );

                if (!upsertsPromises.length) {
                    this.setState({
                        isLoading: false,
                    });
                    return;
                }
                if (upcoming_visit) {
                    this.setState({
                        upcoming_visit,
                    });
                }

                await Promise.all(upsertsPromises);

                await this.setUp();

                this.setState({
                    isLoading: false,
                });
            })
            .catch((e) => {
                console.error(e);
                captureError(e as Error);
                alert('Failed to fetch latest details of the patient [5]');
            });
    };

    componentDidUpdate = (prevProps: Props): void => {
        if (prevProps.vId !== this.props.vId) {
            this.fetchDeets(this.state.allVisits);
        }
    };

    fetchDeets = async (allVisits: Visit[]): Promise<void> => {
        const { vId, goToVisit } = this.props;

        if (!vId) {
            this.setState({
                allVisits,
            });
            allVisits && allVisits.length > 0 && goToVisit(allVisits[0].id);

            return;
        }

        const v: (VisitWithLocalMassaging & { draft?: Draft }) | undefined = allVisits.find(
            (item) => item.id === vId,
        );

        if (!v) {
            console.error('visit not found');
            allVisits && allVisits.length > 0 && goToVisit(allVisits[0].id);

            return;
        }

        if (v.status === 'CMNP' || v.status === 'NS' || v.status === 'AB' || v.status === 'BK') {
            this.setState({
                visit: v,
                allVisits,
                selectedTab:
                    v.status === 'BK'
                        ? 'digital-prescription'
                        : !v.localInCompletePxId || v.localInCompletePxId.length === 0
                        ? 'sa'
                        : 'prescription',
                prescription: {
                    ...v.draft?.data.tool,
                } as any,
            });
            return;
        }

        let px: Px | undefined;

        try {
            px = await fetchPrescriptionById(v.prescriptionId);
        } catch (e) {
            console.error(e);
        }

        if (!px) {
            console.error('Px not found from server');
            return;
        }

        const doc = (await getDoctorProfile(px.doctor._id)) || px.doctor;

        if (!doc) {
            alert('Do not have access to the doctor');
            console.error('Do not have access to the doctor');
            return;
        }

        const clinic =
            px.selectedClinicData ||
            doc.profile.professional.clinics?.find(
                (c) => c._id === doc.profile.professional.default_clinic,
            );

        if (clinic) {
            const pres: Prescription = {
                id: px.id,
                date: new Date(px.date),
                doctor: px.doctor || doc,
                patient: {
                    id: px.patient._id,
                    localId: this.props.plId,
                    profile: px.patient.profile,
                },
                visitId: px.visitid,
                clinic,
                patientHistory: px.tool.medicalHistory?.patientHistory,
                ...createDBTool(px),
                type: px.type,
                doc_name: px.doc_name,
            };

            await upsertPrescription(pres);
        }

        const prescription = await getPrescriptionById(v.prescriptionId);

        this.setState({
            prescription,
            visit: v,
            allVisits,
            selectedTab: 'prescription',
        });

        // if (!v.prescriptionUrl) {
        //     this.syncPxForVisit(v);
        // }
    };

    onVisitSelect = (visitId: string): void => {
        this.props.goToVisit(visitId);
    };

    onPrint = async () => {
        const { visit } = this.state;

        track('PRINT_PX', { visit_id: visit?.id });

        if (!visit) {
            return;
        }
        const url = getPxPrintUrl(visit.prescriptionId);

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (url && (isIPad() || window.userAgent?.isTablet)) {
            window.open(url);
            return;
        }

        const settings = await getItemFromMisc<GenieSettings>(
            getMyIdWithBackwardCompatibility() || '',
            MISC_KEYS.settings,
        );

        if (settings.openPrintPdfInNewTab) {
            window.open(url);
            return;
        }

        if (!this.state.visit?.prescriptionId) {
            return;
        }

        const iframe = document.getElementById(PX_PDF_ELEMENT_ID) as HTMLIFrameElement;
        if (iframe?.contentWindow) {
            iframe?.contentWindow?.print();
        } else {
            window.open(url);
        }
    };

    onSaveAsTemplate = async (name: string, id?: string): Promise<void> => {
        const pxId = this.state.createTemplateVisit?.prescriptionId;

        if (!pxId) {
            alert('Something went wrong');
            this.closeCreateTemplateDialog();
            return;
        }

        let px: Px | undefined;

        try {
            px = await fetchPrescriptionById(pxId);
        } catch (e) {
            alert('Unable to fetch prescription');
            this.closeCreateTemplateDialog();
            return;
        }

        const { dispatch } = this.props;
        dispatch(createPrescriptionTemplate('PX', name, id, px?.tool));
        this.closeCreateTemplateDialog();
    };

    closeCreateTemplateDialog = (): void => {
        this.setState({
            createTemplateVisit: undefined,
        });
    };
    onFailure = async ({ visit }: { visit: VisitWithLocalMassaging }): Promise<void> => {
        await openPrescriptionPadForVisit(this, { aid: visit.id } as AP, undefined);
    };

    onSuccess = (prescriptionId: string, visit: VisitWithLocalMassaging): void => {
        const shouldOpenSA = visit.saId;

        this.props.history.push({
            pathname: GO_TO_PRESCRIPTION_PAD(
                prescriptionId,
                'edit',
                shouldOpenSA ? 'patient-overview' : undefined,
            ),
        });

        if (shouldOpenSA) {
            track('OPEN_SA', {
                channel: 'APPOINTMENTS_START_VISIT',
                apptVisitType: visit.visitType,
            });
        }
    };
    onSaveNotesClick = async ({ visit }: { visit: VisitWithLocalMassaging }): Promise<void> => {
        const { dispatch } = this.props;
        dispatch(setIsNotesMode(true));
        const patient = await getPatientByLocalId(visit.patient.localId);
        const initVisitAction = initVisit(
            {
                id: visit.patient.id,
                localId: visit.patient.localId,
                uuid: visit.patient.uuid,
                name: visit.patient.name.f,
                phoneNumber: visit.patient.phone?.n || '',
                phCode: visit.patient.phone?.c || '',
                gender: patient.personal.gender,
                age: patient.personal.age,
                formData: patient.formData || visit.patient.formData,
                abha: Array.isArray(patient.abhaV2)
                    ? patient.abhaV2?.find((abha) => abha.cId === visit.clinicId)
                    : patient?.abha,
                relations: patient.relations,
            },
            visit.docid,
            visit.clinicId as string,
            visit.id,
            (prescriptionId: string) => this.onSuccess(prescriptionId, visit),
            undefined,
            {
                visitType: visit.visitType,
                saId: visit.saId || undefined,
                autoCopy: true,
                avoidTriggerBEStartVisit: true,
            },
            () => this.onFailure({ visit }),
        );
        track('Update_Notes', { from: 'Patient_Details' });
        initVisitAction && this.props.dispatch(initVisitAction);
    };

    syncPxForVisit = async (
        v: Visit,
        force: boolean = false,
        ignoredraft: boolean = false,
    ): Promise<void> => {
        track('SYNCING_PX');

        const pxId = v.prescriptionId;

        const prescription = await getPrescriptionById(pxId);

        if (!prescription) {
            alert('Prescription not found');
            return;
        }

        const printCofig = await getPrintConfig(getMyDbId() || '');

        this.setState({
            isResyncing: true,
        });

        const templates = getTemplates();

        // TODO consolidate with finished panel
        pushVisit(
            prescription,
            v.startedAt || new Date(),
            v.endedAt || new Date(),
            'send',
            printCofig,
            {
                flag: false,
                lang: '',
            },
            templates?.send?.templateId,
            undefined,
            undefined,
            force,
            undefined,
            ignoredraft,
            prescription.meta?.draftId,
        )
            .then(async (response) => {
                await updatePrescriptionUrlAndVisitNameInVisit(
                    v.id,
                    response.visitName ||
                        generateVisitName(new Date(v.createdAt).toString(), prescription),
                    response.url,
                );

                if (response.pid) {
                    const pt = await getPatientByLocalId(v.patient.localId);

                    if (!pt) {
                        console.error('WTF, no pt with localId found');
                    } else {
                        // remove zoombie pt => update pid
                        await deletePatientByLocalId(pt.localId);

                        const newPt = { ...pt, localId: response.pid, id: response.pid };

                        await upsertPatient(newPt);

                        // update pt references in the visits
                        await updatePtInVisit(v.id, {
                            ...v.patient,
                            localId: response.pid,
                            id: response.pid,
                        });

                        // update pt refrerence in the  px
                        await updatePtInPx(prescription.id, {
                            ...prescription.patient,
                            localId: response.pid,
                            id: response.pid,
                        });

                        this.props.onPxSyncComplete(newPt);

                        this.setState({
                            isResyncing: false,
                        });

                        if (this.props.plId === response.pid) {
                            this.onMount();
                        }
                    }
                }

                if (response.status !== 'success') {
                    await markPrescriptionAsPushFailedStatus(prescription.id, 1);
                } else {
                    await markPrescriptionAsPushFailedStatus(prescription.id, 0);
                }
            })
            .catch(async (e) => {
                this.setState({
                    isResyncing: false,
                });

                if (e.message === ALREADY_SAVED) {
                    showOverrideVisitDialog(
                        () => {
                            this.syncPxForVisit(v, true, this.state.isIgnoreDraft);
                            this.setState({
                                isForce: true,
                            });
                        },
                        () => {
                            return;
                        },
                    );
                } else if (e.message === LATEST_DRAFT_NOT_APPLIED) {
                    rxWithoutLatestDraft(
                        () => {
                            window.location.href = GO_TO_FETCH_UPSERT_PRESCRIPTION_WITH_ID(
                                prescription.id,
                            );
                        },
                        () => {
                            this.syncPxForVisit(v, this.state.isForce, true);
                            this.setState({
                                isIgnoreDraft: true,
                            });
                        },
                    );
                }

                console.error('pushData=>', e);
                captureError(e);
                alert('Failed to sync to cloud');
                track('ERROR', { on: 'SYNCING_PX', error: e.message });

                await markPrescriptionAsPushFailedStatus(prescription.id, 1);

                updatePrescriptionUrlAndVisitNameInVisit(
                    v.id,
                    generateVisitName(new Date(v.createdAt).toString(), prescription),
                );
            });
    };

    pushPx = async (): Promise<void> => {
        const v = this.state.visit;

        if (!v) {
            alert('Please select visit to sync');
            return;
        }

        this.syncPxForVisit(v);
    };

    render(): ReactNode {
        const {
            prescription,
            visit,
            allVisits,
            createTemplateVisit,
            isResyncing,
            selectedTab,
            isLoading,
            upcoming_visit,
        } = this.state;

        const { onUseAsTemplate, editPx } = this.props;

        if (allVisits.length === 0 && isLoading) {
            return (
                <div className="flex flex-col col-span-10 h-full items-center justify-center h-full space-y-64 select-none w-full">
                    <div className="pulse">
                        <svg width="16px" height="12px">
                            <polyline id="back" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                            <polyline id="front" points="1 6 4 6 6 11 10 1 12 6 15 6"></polyline>
                        </svg>
                    </div>
                    <p className="text-24 text-neutral-black">Fetching visits...</p>
                </div>
            );
        }

        const { vId: selectedVisitId } = this.props;

        const pres = prescription;

        const isEditNotAllowed = visit && moment(new Date()).diff(visit?.createdAt, 'hours') > 12;

        return (
            <WithKeyboardPressHandling keyName="command+p,ctrl+p" onKeyDown={this.onPrint}>
                <div className="flex col-span-10 h-full overflow-hidden bg-white w-full">
                    <div className="w-30p">
                        <div className="flex flex-col h-full w-full bg-neutral-9 relative fade-visits">
                            <div className="flex flex-col absolute inset-0 overflow-y-auto">
                                <div className="flex flex-col space-y-24 py-16 px-8 lg:px-16 w-full">
                                    {allVisits.length === 0 && (
                                        <div className="space-y-16">
                                            <p className="leading-5 text-12 text-neutral-5 font-700">
                                                {moment().format('MMMM YYYY')}
                                            </p>
                                            <div className="flex flex-col space-y-16">
                                                {Array.from(Array(2)).map((i) => (
                                                    <div
                                                        key={i}
                                                        className="flex items-center w-full space-x-16"
                                                    >
                                                        <div className="w-20 h-32 text-center font-700 bg-neutral-7"></div>
                                                        <div className="flex items-center justify-between h-32 p-8 leading-6 bg-neutral-7 w-87p rounded-32"></div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {allVisits?.map((visit, i) => (
                                        <div key={visit.id} className="space-y-16 w-full">
                                            {(i === 0 ||
                                                moment(visit.createdAt).format('MMMM YYYY') !==
                                                    moment(allVisits[i - 1].createdAt).format(
                                                        'MMMM YYYY',
                                                    )) && (
                                                <p className="leading-5 text-12 text-neutral-5 font-700">
                                                    {moment(visit.createdAt).format('MMMM YYYY')}
                                                </p>
                                            )}
                                            {upcoming_visit || i !== 0 ? null : (
                                                <>
                                                    <div className="flex flex-row text-darwin-neutral-1000 h-64 items-center gap-x-8 justify-center">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                            width={16}
                                                            height={16}
                                                            className=""
                                                        >
                                                            <path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z" />
                                                        </svg>
                                                        <div className="font-11">
                                                            No upcoming visits to show
                                                        </div>
                                                    </div>
                                                    <div className="w-full h-1 bg-darwin-neutral-100" />
                                                </>
                                            )}
                                            <VisitDataWrapper status={visit.status}>
                                                <div className="flex flex-col space-y-16 w-full">
                                                    <div
                                                        onClick={() => this.onVisitSelect(visit.id)}
                                                        className="flex items-center space-x-10 lg:space-x-16 cursor-pointer w-full"
                                                    >
                                                        <div className="w-10p text-center font-700">
                                                            <p
                                                                className={
                                                                    selectedVisitId !== visit.id
                                                                        ? 'text-18 text-neutral-5'
                                                                        : 'text-18 text-neutral-1'
                                                                }
                                                            >
                                                                {new Date(
                                                                    visit.createdAt,
                                                                ).getDate()}
                                                            </p>
                                                            <p className="text-10 text-neutral-5">
                                                                {moment(visit.createdAt).format(
                                                                    'ddd',
                                                                )}
                                                            </p>
                                                        </div>
                                                        <div
                                                            className={
                                                                selectedVisitId === visit.id
                                                                    ? 'flex items-center justify-between w-60p min-w-80p max-w-80p xl:w-90p xl:max-w-90p xl:min-w-90p p-8 leading-6 bg-white rounded-32 shadow-tight-3 transform-gpu scale-103'
                                                                    : 'flex items-center justify-between xl:max-w-90p xl:min-w-90p xl:w-90p w-80p min-w-80p max-w-80p p-8 leading-6 bg-white rounded-32 patient-details-visit-shadow hover:shadow-tight-3 hover:scale-103 transition-all transform-gpu duration-300 ease-in-out'
                                                            }
                                                        >
                                                            <div
                                                                className={
                                                                    'flex items-center  capitalize w-87p'
                                                                }
                                                            >
                                                                <div className="hidden lg:block">
                                                                    {visit?.status &&
                                                                    VISIT_STATUS_ICON[
                                                                        visit?.status
                                                                    ] ? (
                                                                        <div
                                                                            className="flex items-center justify-center w-28 h-28 bg-neutral-8 rounded-full"
                                                                            style={
                                                                                visit?.status ===
                                                                                'BK'
                                                                                    ? {
                                                                                          backgroundColor:
                                                                                              '#FAE6DA',
                                                                                      }
                                                                                    : undefined
                                                                            }
                                                                        >
                                                                            {
                                                                                VISIT_STATUS_ICON[
                                                                                    visit?.status
                                                                                ]
                                                                            }
                                                                        </div>
                                                                    ) : (
                                                                        <div
                                                                            className="flex items-center justify-center rounded-full w-28 h-28 bg-docM-tab-bg text-docM-rad-main text-11"
                                                                            style={
                                                                                isMrVisit(visit)
                                                                                    ? {
                                                                                          background:
                                                                                              '#FDF7E7',
                                                                                      }
                                                                                    : isBusinessVisit(
                                                                                          visit,
                                                                                      )
                                                                                    ? {
                                                                                          color:
                                                                                              '#19A66A',
                                                                                          background:
                                                                                              '#D1EDE1',
                                                                                      }
                                                                                    : undefined
                                                                            }
                                                                        >
                                                                            {isMrVisit(visit) ? (
                                                                                <svg
                                                                                    viewBox="0 0 448 512"
                                                                                    className="w-12 h-14"
                                                                                    fill="#8E6807"
                                                                                >
                                                                                    <path d="M433.9 98L350 14.1C341 5.1 328.8 0 316.1 0h-204c-26.5.1-48 21.6-48 48.1V288H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h126.1l34.7 69.5c2.9 5.9 11.4 5.9 14.3 0L240 275.8l22.1 44.2H352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-70.1l-34.7-69.5c-2.9-5.9-11.4-5.9-14.3 0L176 332.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H96V48.1c0-8.8 7.3-16.1 16.1-16.1h176v104.1c0 13.3 10.7 23.9 24 23.9h104v304c0 8.8-7.2 16-16 16h-288c-8.8 0-16.1-7.2-16.1-16V352H64.1v112c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V132c0-12.7-5.1-25-14.1-34zM320 128.1V32.6c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9c2.1 2.1 3.5 4.6 4.2 7.4H320z"></path>
                                                                                </svg>
                                                                            ) : isBusinessVisit(
                                                                                  visit,
                                                                              ) ? (
                                                                                <p>
                                                                                    {parseDoctorName(
                                                                                        visit.doc_name,
                                                                                    )}
                                                                                </p>
                                                                            ) : (
                                                                                <p>Rx</p>
                                                                            )}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div
                                                                    className={`lg:ml-8 text-13 truncate w-full font-700
                                                                ${
                                                                    selectedVisitId === visit.id
                                                                        ? ' text-neutral-1'
                                                                        : ' text-neutral-5'
                                                                }
                                                            `}
                                                                >
                                                                    {isBusinessVisit(visit)
                                                                        ? `${visit.doc_name}`
                                                                        : visit.name ||
                                                                          generateVisitName(
                                                                              new Date(
                                                                                  visit.createdAt,
                                                                              ).toString(),
                                                                              pres,
                                                                          )}
                                                                </div>
                                                            </div>
                                                            <div className="flex justify-center items-center w-16 h-16">
                                                                <svg
                                                                    width="14"
                                                                    height="14"
                                                                    className={
                                                                        selectedVisitId !== visit.id
                                                                            ? 'fill-neutral-1 cursor-pointer fill-neutral-1'
                                                                            : 'fill-neutral-5 cursor-pointer fill-neutral-5'
                                                                    }
                                                                    role="img"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 320 512"
                                                                >
                                                                    <path d="M113.3 47.41l183.1 191.1c4.469 4.625 6.688 10.62 6.688 16.59s-2.219 11.97-6.688 16.59l-183.1 191.1c-9.152 9.594-24.34 9.906-33.9 .7187c-9.625-9.125-9.938-24.38-.7187-33.91l168-175.4L78.71 80.6c-9.219-9.5-8.906-24.78 .7187-33.91C88.99 37.5 104.2 37.82 113.3 47.41z"></path>
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </VisitDataWrapper>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {allVisits.length === 0 ? (
                        <div className="flex flex-1 flex-col items-center justify-center h-full space-y-16 select-none">
                            <div>
                                <svg
                                    viewBox="0 0 448 512"
                                    width="42"
                                    height="48"
                                    className="fill-neutral-3"
                                >
                                    <path d="M400 64h-48V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H128V12c0-6.6-5.4-12-12-12h-8c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM48 96h352c8.8 0 16 7.2 16 16v48H32v-48c0-8.8 7.2-16 16-16zm352 384H48c-8.8 0-16-7.2-16-16V192h384v272c0 8.8-7.2 16-16 16zm-105.3-95.9c4.7 4.7 4.7 12.3 0 17l-5.7 5.7c-4.7 4.7-12.3 4.7-17 0l-48-48.2-48.1 48.1c-4.7 4.7-12.3 4.7-17 0l-5.7-5.7c-4.7-4.7-4.7-12.3 0-17l48.1-48.1-48.1-48.1c-4.7-4.7-4.7-12.3 0-17l5.7-5.7c4.7-4.7 12.3-4.7 17 0l48.1 48.1 48.1-48.1c4.7-4.7 12.3-4.7 17 0l5.7 5.7c4.7 4.7 4.7 12.3 0 17L246.6 336l48.1 48.1z"></path>
                                </svg>
                            </div>
                            <div>
                                <p className="text-neutral-3">No visits from this patient yet</p>
                            </div>
                        </div>
                    ) : (
                        <div className="flex flex-col bg-white w-70p patient-details-viewport-shadow h-full overflow-hidden">
                            <div className="flex w-full border-b border-light">
                                <div className="flex select-none cursor-pointer">
                                    <p
                                        onClick={() => this.setSelectedTab('prescription')}
                                        className={`px-16 py-4 text-13 text-actionPrimary-active ${
                                            selectedTab === 'prescription'
                                                ? 'border-actionPrimary-active border-b-2 rounded-b-2'
                                                : ''
                                        } font-700`}
                                    >
                                        Prescription
                                    </p>
                                    <p
                                        onClick={() => this.setSelectedTab('digital-prescription')}
                                        className={`px-16 py-4 text-13 text-actionPrimary-active ${
                                            selectedTab === 'digital-prescription'
                                                ? 'border-actionPrimary-active border-b-2 rounded-b-2'
                                                : ''
                                        } font-700`}
                                    >
                                        Digital Prescription
                                    </p>
                                    <p
                                        onClick={() => this.setSelectedTab('notes')}
                                        className={`px-16 py-4 text-13 text-actionPrimary-active ${
                                            selectedTab === 'notes'
                                                ? 'border-actionPrimary-active border-b-2 rounded-b-2'
                                                : ''
                                        } font-700`}
                                    >
                                        Notes
                                    </p>
                                    <p
                                        onClick={() =>
                                            isSelfVisit(visit) ? this.setSelectedTab('video') : ''
                                        }
                                        className={`px-16 py-4 text-13 text-actionPrimary-active ${
                                            selectedTab === 'video'
                                                ? 'border-actionPrimary-active border-b-2 rounded-b-2'
                                                : ''
                                        } font-700 ${isSelfVisit(visit) ? '' : 'opacity-70'}`}
                                    >
                                        Video Call Recordings
                                    </p>
                                    <p
                                        onClick={() => this.setSelectedTab('apt-details')}
                                        className={`px-16 py-4 text-13 text-actionPrimary-active ${
                                            selectedTab === 'apt-details'
                                                ? 'border-actionPrimary-active border-b-2 rounded-b-2'
                                                : ''
                                        } font-700`}
                                    >
                                        Appointment Details
                                    </p>
                                    <p
                                        onClick={() =>
                                            isSelfVisit(visit) ? this.setSelectedTab('sa') : ''
                                        }
                                        className={`px-16 py-4 text-13 text-actionPrimary-active ${
                                            selectedTab === 'sa'
                                                ? 'border-actionPrimary-active border-b-2 rounded-b-2'
                                                : ''
                                        } font-700 ${isSelfVisit(visit) ? '' : 'opacity-70'}`}
                                    >
                                        Assessment Summary
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col h-full overflow-hidden">
                                <>
                                    <div className="flex flex-col flex-1 overflow-hidden">
                                        <div
                                            style={{ width: 0, height: 0, visibility: 'hidden' }}
                                            id={RIGHT_PANEL_CONC}
                                        ></div>
                                        {selectedTab === 'prescription' && visit && (
                                            <div key={visit.id} className="h-full overflow-auto">
                                                {visit?.prescriptionUrl ? (
                                                    <PDFViewer
                                                        id={PX_PDF_ELEMENT_ID}
                                                        primaryUrl={getPxPrintUrl(
                                                            visit.prescriptionId,
                                                        )}
                                                        fallbackUrl={
                                                            visit.prescriptionUrl ||
                                                            getPxSendUrl(visit.prescriptionId)
                                                        }
                                                    />
                                                ) : visit.status === 'CMNP' ||
                                                  visit.status === 'AB' ||
                                                  visit.status === 'NS' ||
                                                  visit.status === 'BK' ? (
                                                    <NoPx
                                                        localInCompletePxId={
                                                            visit.localInCompletePxId
                                                        }
                                                    />
                                                ) : pres ? (
                                                    <div style={{ zoom: 0.8 }}>
                                                        <PrescriptionPDFPreview id={pres.id} />
                                                    </div>
                                                ) : null}
                                            </div>
                                        )}

                                        {selectedTab === 'video' && visit && (
                                            <div className="h-full px-16 py-8 space-y-16 overflow-auto">
                                                <VideoRecording visit={visit} />
                                            </div>
                                        )}

                                        {selectedTab === 'sa' && selectedVisitId && (
                                            <div
                                                key={selectedVisitId}
                                                className="flex flex-1 px-16 py-8 space-y-16 overflow-auto relative"
                                            >
                                                <AssessmentSummaryTab
                                                    key={selectedVisitId}
                                                    visitId={selectedVisitId}
                                                />
                                            </div>
                                        )}

                                        {selectedTab === 'digital-prescription' && selectedVisitId && (
                                            <div
                                                key={selectedVisitId}
                                                className="flex flex-1 space-y-16 bg-neutral-9 overflow-auto relative border-l border-darwin-neutral-100"
                                                style={{ paddingTop: 16 }}
                                            >
                                                <RXPreviewPtDetails
                                                    prescription={pres}
                                                    visit={visit}
                                                />
                                            </div>
                                        )}

                                        {selectedTab === 'notes' && (
                                            <div className="h-full px-16 py-8 space-y-16 overflow-auto">
                                                {!pres?.privateNotes?.text ? (
                                                    <>
                                                        <div className="flex flex-1 flex-col items-center justify-center h-full space-y-16 select-none">
                                                            <div>
                                                                <svg
                                                                    width="42"
                                                                    height="48"
                                                                    className="fill-neutral-3"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    viewBox="0 0 384 512"
                                                                >
                                                                    <path d="M369.9,97.9,286,14A48,48,0,0,0,252.1-.1H48A48.16,48.16,0,0,0,0,48V464a48,48,0,0,0,48,48H336a48,48,0,0,0,48-48V131.9A48.23,48.23,0,0,0,369.9,97.9Zm-22.6,22.7a15.73,15.73,0,0,1,4.2,7.4H256V32.5a15.73,15.73,0,0,1,7.4,4.2ZM336,480H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H224V136a23.94,23.94,0,0,0,24,24H352V464A16,16,0,0,1,336,480ZM262.71,369.05l-5.66,5.66a12,12,0,0,1-17,0L192,326.63l-48.08,48.08a12,12,0,0,1-17,0l-5.66-5.66a12,12,0,0,1,0-17L169.37,304l-48.08-48.08a12,12,0,0,1,0-17l5.66-5.66a12,12,0,0,1,17,0L192,281.37l48.08-48.08a12,12,0,0,1,17,0l5.66,5.66a12,12,0,0,1,0,17L214.63,304l48.08,48.08A12,12,0,0,1,262.71,369.05Z" />
                                                                </svg>
                                                            </div>
                                                            <div>
                                                                <p className="text-neutral-3">
                                                                    No private notes from this visit
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        <p className="text-neutral-3 text-20 font-700">
                                                            Your Private Notes
                                                        </p>
                                                        <p
                                                            style={{ whiteSpace: 'pre-line' }}
                                                            className="text-neutral-3"
                                                        >
                                                            <div
                                                                className="flex flex-col tiny-mce"
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        pres?.privateNotes?.text,
                                                                }}
                                                            />
                                                        </p>{' '}
                                                    </>
                                                )}
                                            </div>
                                        )}

                                        {selectedTab === 'apt-details' && selectedVisitId ? (
                                            <apt-activity
                                                aid={selectedVisitId}
                                                class="flex flex-col h-full w-full"
                                            />
                                        ) : null}
                                    </div>

                                    {visit?.prescriptionUrl ? (
                                        <div className="grid grid-rows-2 xl:grid-rows-1 gap-8 p-8 grid-flow-col  justify-items-stretch patient-details-visit-footer overflow-auto">
                                            {visit.status !== 'BK' && visit?.prescriptionId && (
                                                <SaveAsTemplateBt
                                                    onClick={() =>
                                                        this.setState({
                                                            createTemplateVisit: visit,
                                                        })
                                                    }
                                                />
                                            )}
                                            {visit.status !== 'BK' && visit?.prescriptionId && (
                                                <button
                                                    onClick={
                                                        isEditNotAllowed || isBusinessVisit(visit)
                                                            ? () =>
                                                                  visit.prescriptionId &&
                                                                  onUseAsTemplate(
                                                                      visit.prescriptionId,
                                                                  )
                                                            : undefined
                                                    }
                                                    style={
                                                        !isEditNotAllowed && !isBusinessVisit(visit)
                                                            ? { opacity: 0.5 }
                                                            : undefined
                                                    }
                                                    className={`secondary-btn justify-center btn px-8 py-8 btn--small w-full space-x-4 ${getAclViewClassName(
                                                        SREV2.PT_DETAILS_VISIT_ACTIONS,
                                                    )}`}
                                                >
                                                    <div className="w-20 h-20 flex items-center justify-center">
                                                        <svg
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 28 28"
                                                            className="cursor-pointer fill-actionPrimary relative top-1"
                                                        >
                                                            <path d="M16,8H14V11H11V13H14V16H16V13H19V11H16M2,12C2,9.21 3.64,6.8 6,5.68V3.5C2.5,4.76 0,8.09 0,12C0,15.91 2.5,19.24 6,20.5V18.32C3.64,17.2 2,14.79 2,12M15,3C10.04,3 6,7.04 6,12C6,16.96 10.04,21 15,21C19.96,21 24,16.96 24,12C24,7.04 19.96,3 15,3M15,19C11.14,19 8,15.86 8,12C8,8.14 11.14,5 15,5C18.86,5 22,8.14 22,12C22,15.86 18.86,19 15,19Z"></path>
                                                        </svg>
                                                    </div>
                                                    <span className="whitespace-nowrap text-center">
                                                        Use as Template
                                                    </span>
                                                </button>
                                            )}
                                            {visit.status !== 'BK' &&
                                                visit?.prescriptionId &&
                                                editPx &&
                                                (isEditNotAllowed ||
                                                (isBusinessVisit(visit) &&
                                                    !isEditableVisitForMe(visit)) ? (
                                                    <AntTooltip
                                                        content={
                                                            isEditNotAllowed
                                                                ? 'Prescription is only editable within 12 hrs of creation'
                                                                : isBusinessVisit(visit)
                                                                ? "You can't edit Rx which is created by other doctor"
                                                                : undefined
                                                        }
                                                    >
                                                        <button
                                                            style={{ opacity: 0.5 }}
                                                            className={`btn justify-center secondary-btn px-8 py-8 btn--small w-full space-x-4 ${getAclViewClassName(
                                                                SREV2.EDIT_RX,
                                                            )}`}
                                                        >
                                                            <svg
                                                                width="20"
                                                                height="20"
                                                                viewBox="0 0 28 28"
                                                                className="fill-actionPrimary cursor-pointer relative top-1"
                                                            >
                                                                <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"></path>
                                                            </svg>
                                                            <span className="text-center">
                                                                Edit
                                                            </span>
                                                        </button>
                                                    </AntTooltip>
                                                ) : (
                                                    <button
                                                        onClick={() =>
                                                            editPx(visit?.prescriptionId)
                                                        }
                                                        className={`btn justify-center secondary-btn px-8 py-8 btn--small w-full space-x-4 ${getAclViewClassName(
                                                            SREV2.EDIT_RX,
                                                        )}`}
                                                    >
                                                        <svg
                                                            width="20"
                                                            height="20"
                                                            viewBox="0 0 28 28"
                                                            className="fill-actionPrimary cursor-pointer relative top-1"
                                                        >
                                                            <path d="M20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L15.12,5.12L18.87,8.87M3,17.25V21H6.75L17.81,9.93L14.06,6.18L3,17.25Z"></path>
                                                        </svg>
                                                        <span className="text-center">Edit</span>
                                                    </button>
                                                ))}
                                            {!visit.draft && visit && (
                                                <SendSMSBt
                                                    ph={
                                                        (visit?.patient.phone?.c
                                                            ? visit?.patient.phone?.c.replaceAll(
                                                                  '+',
                                                                  '',
                                                              )
                                                            : '') + (visit?.patient.phone?.n || '')
                                                    }
                                                    visitId={visit?.id}
                                                />
                                            )}
                                            <button
                                                onClick={this.onPrint}
                                                className="primary-btn btn px-8 py-8 btn--small w-full justify-center space-x-4"
                                            >
                                                <svg
                                                    width="20"
                                                    height="20"
                                                    viewBox="0 0 28 28"
                                                    className="cursor-pointer fill-white relative top-1"
                                                >
                                                    <path d="M18,3H6V7H18M19,12A1,1 0 0,1 18,11A1,1 0 0,1 19,10A1,1 0 0,1 20,11A1,1 0 0,1 19,12M16,19H8V14H16M19,8H5A3,3 0 0,0 2,11V17H6V21H18V17H22V11A3,3 0 0,0 19,8Z"></path>
                                                </svg>
                                                <span className=" text-center">Print</span>
                                            </button>
                                        </div>
                                    ) : visit && visit.status === 'BK' && editPx ? (
                                        <div
                                            className={`flex p-8 justify-end items-center patient-details-visit-footer overflow-visible ${getAclViewClassName(
                                                SREV2.PT_DETAILS_VISIT_ACTIONS,
                                            )}`}
                                        >
                                            <div>
                                                <button
                                                    onClick={() => {
                                                        this.onSaveNotesClick({ visit });
                                                    }}
                                                    className="secondary-btn justify-center btn px-8 py-8 btn--small w-full space-x-4"
                                                >
                                                    <div className="w-20 h-20 flex items-center justify-center">
                                                        <svg
                                                            width="20"
                                                            height="20"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 576 512"
                                                            className="cursor-pointer fill-actionPrimary relative top-1"
                                                        >
                                                            <path d="M64 464H262.5l-5.1 20.2c-2.3 9.4-1.8 19 1.4 27.8H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V299.6l-48 48V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM549.8 235.7l14.4 14.4c15.6 15.6 15.6 40.9 0 56.6l-29.4 29.4-71-71 29.4-29.4c15.6-15.6 40.9-15.6 56.6 0zM311.9 417L441.1 287.8l71 71L382.9 487.9c-4.1 4.1-9.2 7-14.9 8.4l-60.1 15c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l15-60.1c1.4-5.6 4.3-10.8 8.4-14.9z" />
                                                        </svg>
                                                    </div>
                                                    <span className="whitespace-nowrap text-center">
                                                        Update Notes
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    ) : visit &&
                                      visit.status !== 'CMNP' &&
                                      visit.status !== 'AB' &&
                                      visit.status !== 'NS' &&
                                      visit.status !== 'BK' ? (
                                        <div className="flex p-8 justify-end items-center patient-details-visit-footer overflow-visible">
                                            <div>
                                                <button
                                                    onClick={this.pushPx}
                                                    className="btn justify-center items-center primary-btn px-8 py-8 btn--small w-full sa-tooltip space-x-8"
                                                >
                                                    {isResyncing && (
                                                        <svg
                                                            viewBox="0 0 512 512"
                                                            className="fill-white animate-spin"
                                                            width="20"
                                                            height="20"
                                                        >
                                                            <path d="M456.433 371.72l-27.79-16.045c-7.192-4.152-10.052-13.136-6.487-20.636 25.82-54.328 23.566-118.602-6.768-171.03-30.265-52.529-84.802-86.621-144.76-91.424C262.35 71.922 256 64.953 256 56.649V24.56c0-9.31 7.916-16.609 17.204-15.96 81.795 5.717 156.412 51.902 197.611 123.408 41.301 71.385 43.99 159.096 8.042 232.792-4.082 8.369-14.361 11.575-22.424 6.92z" />
                                                        </svg>
                                                    )}
                                                    <span className="text-center">
                                                        {isResyncing
                                                            ? 'Uploading'
                                                            : 'Save this visit to your cloud'}
                                                    </span>
                                                    <span className="tooltip">
                                                        This visit is not uploaded to cloud yet
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    ) : null}
                                </>
                            </div>
                        </div>
                    )}
                    <AnimatePresence>
                        {createTemplateVisit && (
                            <CreateTemplateComp
                                isModal={true}
                                withPeak={false}
                                kind={ALL_KINDS['PX']}
                                onCancel={this.closeCreateTemplateDialog}
                                onSave={this.onSaveAsTemplate}
                                isCancelActive={true}
                            />
                        )}
                    </AnimatePresence>
                </div>
            </WithKeyboardPressHandling>
        );
    }
}

export default connect()(PastVisitsRightPanel);
export { PastVisitsRightPanel };

const convertVisitToLocalMasaggingFormat = (p: PatientDirPt, v: VisitsEntity) => {
    return {
        id: v.vid,
        patient: {
            localId: p.id,
            id: p.id,
            phone: p.profile.personal.phone,
            name: {
                f: p.profile.personal.name,
            },
        },
        clinicId: v.clinicid,
        createdAt: new Date(v.visit_date),
        prescriptionId: v.pxid,
        isCompleted: 1,
        prescriptionUrl: v.url,
        name: v.name,
        status: v.status,
        draft: v.draft,
        type: v.type,
        doc_name: v.doc_name,
        docid: v.docid,
    };
};

export const AssessmentSummaryTab: React.FC<{
    visitId?: string;
    saId?: string;
    saIds?: string[];
    onPad?: boolean;
    handleCloseSaPopup?: () => void;
}> = ({ visitId, saId, saIds, onPad, handleCloseSaPopup }) => {
    const [fetchState, setFetchState] = useState<'loading' | 'success' | 'error'>('loading');

    const [sa, setSa] = useState<undefined | SA>();

    const fetchDeets = async () => {
        setFetchState('loading');

        try {
            if (visitId) {
                const resp = await fetchAssessmentSummary(visitId);

                if (resp.status !== 'success') {
                    setFetchState('error');
                    return;
                }

                setFetchState('success');
                setSa(resp.response);
            } else if (saId) {
                const resp = await fetchPastAssessmentSummary(saId);

                if (resp.status !== 'success') {
                    setFetchState('error');
                    return;
                }

                setFetchState('success');
                setSa(resp.response);
            } else if (saIds && saIds.length > 0) {
                const resp = await fetchBatchAssessmentSummary(saIds.join(','));

                if (resp.status !== 'success') {
                    setFetchState('error');
                    return;
                }

                setFetchState('success');
                setSa(resp.response);
            }
        } catch (e) {
            setFetchState('error');
        }
    };

    useEffect(() => {
        fetchDeets();
    }, [visitId]);

    useEffect(() => {
        fetchDeets();
    }, [saId]);

    const dispatch = useDispatch();

    const [isSymptomsFilled, setIsSymptomsFilled] = useState(false);
    const [isDiagonisFilled, setIsDiagnosisFilled] = useState(false);
    const [isMHCopied, setIsMHCopied] = useState(false);
    const [isVitalsCopied, setIsVitalsCopied] = useState(false);

    const onSymptomsCopy = () => {
        if (!sa) {
            return;
        }
        const present = filterPresentingSymptoms(sa);

        batch(() => {
            present.forEach(({ mdbid, mdbname, properties }) => {
                track(SELECT, { element: SYMPTOM, channel: CHANNEL_SA });
                dispatch(upsertSymptom({ id: mdbid, name: mdbname, properties }));
            });
        });

        setIsSymptomsFilled(true);
        return;
    };

    const onVitalsCopy = () => {
        if (!sa || !sa.sa?.vitals?.length) {
            return;
        }
        const vitals = sa.sa?.vitals;

        batch(() => {
            vitals
                .filter((t) => t.value?.toString() && t.name)
                .forEach(({ id, name, unit, value, unit_id }) => {
                    track(SELECT, { element: VITAL, channel: CHANNEL_SA });
                    const serverVital = SERVER_VITALS.find((v) => v.id === id);
                    if (serverVital) {
                        const safe = serverVital.units_with_ranges.find(
                            (t) => t.code_id === unit_id,
                        )?.safe;
                        dispatch(
                            updateVitals({
                                name,
                                dis_name: name,
                                id,
                                value: {
                                    qt: value.toString(),
                                    unit,
                                    code_id: unit_id,
                                    safe: safe as VitalsEntity['value']['safe'],
                                },
                                date: new Date().toISOString(),
                                isoDate: new Date().toISOString(),
                            }),
                        );
                    } else {
                        dispatch(
                            upsertLabVital({
                                id,
                                name,
                                unit_dislay_name: unit,
                                value: value.toString(),
                                date: new Date().toISOString(),
                                unit: {
                                    name: unit,
                                    id: unit_id,
                                },
                                all_units: [
                                    {
                                        name: unit,
                                        id: unit_id,
                                    },
                                ],
                            }),
                        );
                    }
                });
        });

        setIsVitalsCopied(true);
        return;
    };

    const onDiagnosisCopy = () => {
        if (!sa) {
            return;
        }

        const present = filterDiagonsis(sa);

        batch(() => {
            present.forEach(({ mdbid, mdbname, properties }) => {
                track(SELECT, { element: DIAGNOSIS, channel: CHANNEL_SA });
                dispatch(upsertDiagnose({ id: mdbid, name: mdbname, properties }));
            });
        });

        setIsDiagnosisFilled(true);
        return;
    };

    const onMHCopy = () => {
        if (!sa) {
            return;
        }
        const mh = filterMedicalHistory(sa);

        batch(() => {
            mh.forEach((item: AssessmentSummaryEntity) => {
                const { mdbid, mdbname, type, meta } = item;
                if (type) {
                    track(SELECT, { element: 'mh', channel: CHANNEL_SA, type });

                    switch (type) {
                        case MH_LH:
                            dispatch(
                                upsertMedicalHistory(MEDICAL_HISTORY_CATEGORY['LIFESTYLE_HABITS'], {
                                    id: mdbid,
                                    name: mdbname,
                                    status: 'Active',
                                }),
                            );
                            break;

                        case MH_MC:
                            dispatch(
                                upsertMedicalHistory(
                                    MEDICAL_HISTORY_CATEGORY['PATIENT_MEDICAL_CONDITIONS'],
                                    {
                                        id: mdbid,
                                        name: mdbname,
                                        status: 'Active',
                                    },
                                ),
                            );
                            break;
                        case MH_FA:
                            dispatch(
                                upsertMedicalHistory(
                                    MEDICAL_HISTORY_CATEGORY['FOOD_OTHER_ALLERGY'],
                                    {
                                        id: mdbid,
                                        name: mdbname,
                                        status: 'Active',
                                    },
                                ),
                            );
                            break;
                        case MH_FH:
                            if (meta.who) {
                                dispatch(
                                    upsertMedicalHistory(
                                        MEDICAL_HISTORY_CATEGORY['FAMILY_HISTORY'],
                                        {
                                            id: mdbid,
                                            name: mdbname,
                                            who: meta.who,
                                            status: 'Active',
                                        },
                                    ),
                                );
                            } else {
                                track('ERROR', { on: 'onMHCopy', what: 'fh: who not found' });
                            }
                            break;
                        case MH_PP:
                            if (meta.on) {
                                dispatch(
                                    upsertMedicalHistory(
                                        MEDICAL_HISTORY_CATEGORY['PAST_PROCEDURES'],
                                        {
                                            id: mdbid,
                                            name: mdbname,
                                            status: 'Active',

                                            reportedAt: meta.reportedAt,
                                            notes: meta.notes,
                                            on: meta.on,
                                        },
                                    ),
                                );
                            } else {
                                track('ERROR', { on: 'onMHCopy', what: 'pp: on not found' });
                            }
                            break;
                    }
                } else {
                    track('ERROR', { on: 'onMHCopy', what: 'type not found' });
                }
            });
        });

        setIsMHCopied(true);
        return;
    };

    if (fetchState === 'loading') {
        return (
            <div className="flex flex-1 justify-center items-center">
                <AppLoader />
            </div>
        );
    }

    if (fetchState === 'error') {
        return <AssessmentSummaryError onTryAgain={fetchDeets} />;
    }

    return sa ? (
        <AssessmentSummary
            gridCol={1}
            isOnPad={onPad}
            assessmentSummary={sa}
            onDiagnosisCopy={onPad ? onDiagnosisCopy : undefined}
            onSymptomsCopy={onPad ? onSymptomsCopy : undefined}
            onMHCopy={onPad ? onMHCopy : undefined}
            onVitalsCopy={onPad ? onVitalsCopy : undefined}
            isSymptomsFilled={onPad ? isSymptomsFilled : undefined}
            isDiagonisFilled={onPad ? isDiagonisFilled : undefined}
            isMHCopied={onPad ? isMHCopied : undefined}
            isVitalsCopied={onPad ? isVitalsCopied : undefined}
            handleCloseSaPopup={handleCloseSaPopup}
        />
    ) : null;
};
